import React, { useEffect, useState } from 'react'
import { Panel, Row, Col, Message } from 'rsuite'
// import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import EditFormWidget from './EditFormWidget'
import CustomAlertMessage from '../../CustomAlertMessage'
import { cloneDeep } from 'lodash-es'

export default function EditFormTableWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  handleSubmit,
  loading,
  isEdit = false,
  notiMsg,
  objectDatas,
  preView,
  conditions = [],
  setNotiMsg = () => {},
  setLoading = () => {},
  onDelete = () => {},
  onSave = () => {},
  onCancel = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isAdd, setIsAdd] = useState(false)

  useEffect(() => {
    if (isEdit) {
      setIsAdd(false)
    }
  }, [isEdit])

  useEffect(() => {
    if (notiMsg?.type == 'success') {
      let isAddNew = cloneDeep(isAdd)
      setIsAdd(false)
      if (isAddNew) {
        setTimeout(() => {
          setIsAdd(true)
        }, 100)
      }
    }
  }, [notiMsg])

  const handleAdd = () => {
    onCancel()
    setIsAdd(true)
  }

  return (
    <Panel>
      <Row>
        {schema.description && schema.description.length > 0 && (
          <Col style={{ marginBottom: 15 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}

        {!isAdd && !isEdit && <SaveButton icon="plus" children="เพิ่ม" onClick={handleAdd} />}

        {(isAdd || isEdit) && (
          <>
            <EditFormWidget
              ignoreDesc
              schema={schema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              objectDatas={objectDatas}
              conditions={conditions}
            />

            <Row style={{ marginTop: 10, textAlign: 'right' }}>
              <hr />
              {notiMsg && (
                <Message
                  closable
                  showIcon
                  type={notiMsg.type}
                  description={notiMsg.msg}
                  onClose={() => setNotiMsg('')}
                  style={{ marginBottom: 10 }}
                  className="left"
                />
              )}

              <>
                {!preView && <SaveButton children="บันทึก" onClick={handleSubmit(onSave)} />}
                <CancelButton
                  children="ยกเลิก"
                  onClick={() => {
                    setIsAdd(false)
                    onCancel()
                  }}
                />
              </>
            </Row>
          </>
        )}
      </Row>
    </Panel>
  )
}
